module.exports = __webpack_public_path__ + "static/media/executionerSound3.b4995650.mp3";